<template>
  <section class="game">
    <template v-if="gameSelected === null" class="select-game">
      <div style="display: flex;">
        <h2 class="games-text">{{ $t('global.games') }}</h2>
        <h2 class="games-title">{{ $t('global.titleGames') }}</h2>
        <button type="button" class="btn btn-info btn-cont" @click="nextCluster">
          {{ $t('global.gameDone') }}
        </button>
      </div>
      <h3 class="game-tips">{{ $t('global.gameTips') }}</h3>
      <div class="row">
        <div
          v-for="game in games"
          :key="game.name"
          class="col-6 col-sm-4 col-md-3 col-lg-3 p-3"
          @click="selectGame(game.path)"
        >
          <div
            class="game-info"
            :style="{
              background: `linear-gradient(rgba(0, 0, 0,0.65), rgba(0, 0, 0, 0.65)), url(${game.thumb})`,
              height: `10em`,
            }"
          >
            {{ game.name }}
          </div>
        </div>
      </div>
      <!-- <div class="btn-continue">
        <button type="button" class="btn btn-info" @click="nextCluster">
          {{ $t('global.gameDone') }}
        </button>
      </div> -->
    </template>
    <template v-else>
      <button class="btn btn-danger" @click="allGames">Exit</button>
      <iframe :src="gameSelected" frameborder="0" class="game-container"></iframe>
    </template>
  </section>
  <!-- <div id="games">
      <div class="games-text">{{ $t('global.games') }}</div>
      <div class="row">
        <div v-if="gameSelected === null" class="select-game">
          <h1>{{ $t('global.titleGames') }}</h1>
          <div
            v-for="game in games"
            :key="game.name"
            :style="{
              background: `linear-gradient(rgba(0, 0, 0,155), rgba(0, 0, 0, 0.65)), url(${game.thumb})`,
            }"
            class="col-md-6"
            @click="selectGame(game.path)"
          >
            {{ game.name }}
          </div>
        </div>
        <iframe v-else :src="gameSelected" frameborder="0" class="game-container"></iframe>
      </div>
      <div class="btn-continue">
        <button type="button" class="btn btn-info" @click="nextCluster">
          {{ $t('global.gameDone') }}
        </button>
      </div>
    </div>-->
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      games: [
        {
          name: '2048',
          path: 'static/games/2048-master/index.html',
          thumb: 'static/games/thumbnails/2048.jpg',
        },
        {
          name: 'AlienInvasion',
          path: 'static/games/AlienInvasion/index.html',
          thumb: 'static/games/thumbnails/alieninvasion.jpg',
        },
        {
          name: 'Clumsy bird',
          path: 'static/games/clumsy-bird-master/index.html',
          thumb: 'static/games/thumbnails/clumsybird.jpg',
        },
        {
          name: 'Coffee snake',
          path: 'static/games/coffee-snake-master/index.html',
          thumb: 'static/games/thumbnails/snake.jpg',
        },
        {
          name: 'Asteroids',
          path: 'static/games/HTML5-Asteroids-master/index.html',
          thumb: 'static/games/thumbnails/asteroids.jpg',
        },
        {
          name: 'Parity',
          path: 'static/games/parity-master/index.html',
          thumb: 'static/games/thumbnails/parity.jpg',
        },
        {
          name: 'Sudoku',
          path: 'static/games/sudoku-js-master/sudoku.html',
          thumb: 'static/games/thumbnails/sudoku.jpg',
        },
        {
          name: 'Swap',
          path: 'static/games/swap-master/index.html',
          thumb: 'static/games/thumbnails/swap.jpg',
        },
        {
          name: 'Custom tetris',
          path: 'static/games/custom-tetris-master/index.html',
          thumb: 'static/games/thumbnails/tetris.jpg',
        },
        {
          name: 'Digger',
          path: 'static/games/digger-master/index.html',
          thumb: 'static/games/thumbnails/digger.jpg',
        },
        {
          name: 'Matching pairs',
          path: 'static/games/matching-pairs-master/index.html',
          thumb: 'static/games/thumbnails/pairs.jpg',
        },
      ],
      gameSelected: null,
      goBack: false,
    };
  },
  computed: {
    ...mapGetters({
      nextClusterVar: 'cluster/nextCluster',
      currentCluster: 'cluster/currentCluster',
    }),
  },
  created() {
    switch (this.$route.params.grade_id) {
      case '9':
        Array.prototype.push.apply(this.games, [
          {
            name: 'Memory 1',
            path: 'static/games/first-grade/MG1_01/index.html',
            thumb: 'static/games/thumbnails/memory1.jpg',
          },
          {
            name: 'Memory 2',
            path: 'static/games/first-grade/MG1_02/index.html',
            thumb: 'static/games/thumbnails/memory2.jpg',
          },
          {
            name: 'Memory 3',
            path: 'static/games/first-grade/MG1_03/index.html',
            thumb: 'static/games/thumbnails/memory3.jpg',
          },
          {
            name: 'Memory 4',
            path: 'static/games/first-grade/MG1_04/index.html',
            thumb: 'static/games/thumbnails/memory4.jpg',
          },
        ]);
        break;
      case '55':
        Array.prototype.push.apply(this.games, [
          {
            name: 'Jigzaw 1',
            path: 'static/games/second-grade/jizgaw_prod1/index.html',
            thumb: 'static/games/thumbnails/jigzaw1.jpg',
          },
          {
            name: 'Jigzaw 2',
            path: 'static/games/second-grade/jizgaw_prod2/index.html',
            thumb: 'static/games/thumbnails/jigzaw2.jpg',
          },
          {
            name: 'Jigzaw 3',
            path: 'static/games/second-grade/jizgaw_prod3/index.html',
            thumb: 'static/games/thumbnails/jigzaw3.jpg',
          },
          {
            name: 'Jigzaw 4',
            path: 'static/games/second-grade/jizgaw_prod4/index.html',
            thumb: 'static/games/thumbnails/jigzaw4.jpg',
          },
        ]);
        break;
      case '109':
        Array.prototype.push.apply(this.games, [
          {
            name: 'Catch the numbers 1',
            path: 'static/games/third-grade/catch_the_numbers_prod1/index.html',
            thumb: 'static/games/thumbnails/catchthenumbers.jpg',
          },
          {
            name: 'Catch the numbers 2',
            path: 'static/games/third-grade/catch_the_numbers_prod2/index.html',
            thumb: 'static/games/thumbnails/catchthenumbers.jpg',
          },
          {
            name: 'Catch the numbers 3',
            path: 'static/games/third-grade/catch_the_numbers_prod3/index.html',
            thumb: 'static/games/thumbnails/catchthenumbers.jpg',
          },
          {
            name: 'Catch the numbers 4',
            path: 'static/games/third-grade/catch_the_numbers_prod4/index.html',
            thumb: 'static/games/thumbnails/catchthenumbers.jpg',
          },
        ]);
        break;
      case '157':
        Array.prototype.push.apply(this.games, [
          {
            name: 'Hangman 1',
            path: 'static/games/fourth-grade/hangman1/index.html',
            thumb: 'static/games/thumbnails/hangman1.jpg',
          },
          {
            name: 'Hangman 2',
            path: 'static/games/fourth-grade/hangman2/index.html',
            thumb: 'static/games/thumbnails/hangman2.jpg',
          },
          {
            name: 'Hangman 3',
            path: 'static/games/fourth-grade/hangman3/index.html',
            thumb: 'static/games/thumbnails/hangman1.jpg',
          },
          {
            name: 'Hangman 4',
            path: 'static/games/fourth-grade/hangman4/index.html',
            thumb: 'static/games/thumbnails/hangman2.jpg',
          },
        ]);
        break;
      case '200':
        Array.prototype.push.apply(this.games, [
          {
            name: 'Jeopardy 1',
            path: 'static/games/fifth-grade/JEOPARDY_1/index.html',
            thumb: 'static/games/thumbnails/jeopardy.jpg',
          },
          {
            name: 'Jeopardy 2',
            path: 'static/games/fifth-grade/JEOPARDY_2/index.html',
            thumb: 'static/games/thumbnails/jeopardy.jpg',
          },
          {
            name: 'Millionaire 1',
            path: 'static/games/fifth-grade/MILLIONAIRE_1/index.html',
            thumb: 'static/games/thumbnails/millionaire.jpg',
          },
          {
            name: 'Millionaire 2',
            path: 'static/games/fifth-grade/MILLIONAIRE_2/index.html',
            thumb: 'static/games/thumbnails/millionaire.jpg',
          },
        ]);
        break;
      case '250':
        Array.prototype.push.apply(this.games, [
          {
            name: 'Word Search 1',
            path: 'static/games/sixth-grade/WS6_1/index.html',
            thumb: 'static/games/thumbnails/wordsearch.jpg',
          },
          {
            name: 'Word Search 2',
            path: 'static/games/sixth-grade/WS6_2/index.html',
            thumb: 'static/games/thumbnails/wordsearch.jpg',
          },
          {
            name: 'Word Search 3',
            path: 'static/games/sixth-grade/WS6_3/index.html',
            thumb: 'static/games/thumbnails/wordsearch.jpg',
          },
          {
            name: 'Word Search 4',
            path: 'static/games/sixth-grade/WS6_4/index.html',
            thumb: 'static/games/thumbnails/wordsearch.jpg',
          },
        ]);
        break;
    }
    this.games = _.shuffle(this.games);
  },
  methods: {
    selectGame(gamePath) {
      this.goBack = true;
      this.gameSelected = gamePath;
    },
    nextCluster() {
      // var path =
      //   'level/' +
      //   //this.$route.params.level +
      //   'grade/' +
      //   this.$route.params.grade_id +
      //   '/subject/' +
      //   this.$route.params.subject_id +
      //   //'cluster/' +
      //   '?cluster_id=' +
      //   this.$route.params.cluster_id;

      // this.nextClusterVar
      //   ? this.$router.push({ name: 'subject', query: { cluster_id: this.nextClusterVar.id } })
      //   : this.$router.push({ name: 'subject', query: { cluster_id: this.currentCluster.id } });

      this.$router.push({ name: 'subject', query: { cluster_id: this.$route.params.cluster_id } });
    },
    allGames() {
      location.reload();
    },
  },
  beforeRouteEnter: (to, from, next) => {
    next();
  },
};
</script>
<style lang="scss" scoped>
#games {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  user-select: none;
}
.container {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
.game-container {
  // position: absolute;
  // height: 100%;
  height: 94vh;
  width: 100%;
}
.games-text {
  font-family: 'comfortaabold';
  text-shadow: 3px 3px 15px black;
  color: white;
  font-size: 40px;
  border-radius: 5px;
  margin-top: 15px;
  position: absolute;
  top: 10px;
  left: 0.8em;
}
.game-info {
  cursor: pointer;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13pt;
  font-family: 'comfortaabold';
  border-radius: 5px;
  max-width: 300px;
  margin: auto;
}
.btn-continue {
  position: relative;
  top: 10px;
  right: 10px;
  float: right;
}
.btn-cont {
  position: relative;
  top: 30px;
  right: 10px;
  float: right;
  height: 37px;
}
.games-title {
  font-family: 'comfortaabold';
  text-align: center;
  margin: 1em auto;
  @media (max-width: 576px) {
    visibility: hidden;
  }
}
.game-tips {
  text-align: center;
  margin-top: 25px;
  visibility: hidden;
  @media (max-width: 576px) {
    visibility: visible;
  }
}
.game {
  max-width: 1600px;
  margin: auto;
}
.select-game {
  display: grid;
  grid-template: 50px repeat(3, minmax(75px, 125px)) 50px / repeat(5, minmax(75px, 125px));
  grid-gap: 25px;
  align-content: center;
  justify-content: center;
  height: 100%;
  h1 {
    grid-column-start: 1;
    grid-column-end: span 5;
    margin-bottom: 0px;
    font-family: 'comfortaabold';
    text-align: center;
  }
  button {
    color: #fff;
    font-family: 'comfortaabold';
    border-radius: 5px;
    border: none;
    cursor: pointer;
  }
}
.btn-danger {
  width: 85px;
  height: 33px;
  position: absolute;
  left: 1em;
}
@media (max-width: 360px) {
  .btn-danger {
    font-size: 11pt;
    height: 30px;
  }
  .btn-cont {
    font-size: 11pt;
    height: 30px;
  }
}
@media (max-width: 1200px) {
  .btn-cont {
    position: absolute;
    margin-right: 17px;
  }
}
@media (max-height: 450px) {
  .btn-danger {
    z-index: 999;
  }
}
</style>
